import React from "react";
import styled from "styled-components";

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 40px;
  text-align: center;
`;

const ErrorTitle = styled.h1`
  color: #d32f2f;
  font-size: 24px;
  margin-bottom: 16px;
`;

const ErrorMessage = styled.p`
  color: #666;
  font-size: 16px;
  margin-bottom: 24px;
  max-width: 600px;
`;

const ErrorDetails = styled.pre`
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  overflow-x: auto;
  max-width: 800px;
  text-align: left;
`;

const ReloadButton = styled.button`
  background-color: #3398b8;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 16px;

  &:hover {
    background-color: #287a94;
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <ErrorTitle>Something went wrong</ErrorTitle>
          <ErrorMessage>
            We encountered an unexpected error. Please try reloading the page.
            If the problem persists, contact support.
          </ErrorMessage>
          {process.env.NODE_ENV === "development" && this.state.error && (
            <ErrorDetails>
              <div><strong>Error:</strong> {this.state.error.toString()}</div>
              {this.state.errorInfo && (
                <div>
                  <strong>Stack trace:</strong>
                  {this.state.errorInfo.componentStack}
                </div>
              )}
            </ErrorDetails>
          )}
          <ReloadButton onClick={this.handleReload}>
            Reload Page
          </ReloadButton>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
